// Tipos de actividad ofrecidos como "seguimiento" en los formularios de Leads/Contactos.
// Nota: Activity.type en el backend admite más valores ('email', 'note', 'system',
// 'form'), pero esos se generan automáticamente o tienen su propio composer — no se
// ofrecen aquí para no duplicar UI. Los que igual hay que saber pintar en la línea
// de tiempo van en DISPLAY_ONLY_TYPES, más abajo.
export const FOLLOW_UP_TYPES = [
    { value: 'call', label: 'Llamada', icon: 'call', color: 'text-purple-600 dark:text-purple-400', bg: 'bg-purple-100 dark:bg-purple-900/50' },
    { value: 'meeting', label: 'Reunión', icon: 'groups', color: 'text-blue-600 dark:text-blue-400', bg: 'bg-blue-100 dark:bg-blue-900/50' },
    { value: 'task', label: 'Tarea', icon: 'task_alt', color: 'text-amber-600 dark:text-amber-400', bg: 'bg-amber-100 dark:bg-amber-900/50' },
    { value: 'whatsapp', label: 'WhatsApp', icon: 'chat', color: 'text-green-600 dark:text-green-400', bg: 'bg-green-100 dark:bg-green-900/50' },
];

// Tipos que el sistema genera solo y hay que saber mostrar, pero que nadie
// elige a mano: van aparte de FOLLOW_UP_TYPES para no aparecer como opción en
// el selector de seguimiento.
export const DISPLAY_ONLY_TYPES = [
    { value: 'form', label: 'Formulario', icon: 'dynamic_form', color: 'text-teal-600 dark:text-teal-400', bg: 'bg-teal-100 dark:bg-teal-900/50' },
];

export function getFollowUpTypeMeta(type) {
    return FOLLOW_UP_TYPES.find(t => t.value === type)
        || DISPLAY_ONLY_TYPES.find(t => t.value === type)
        || {
            value: type, label: type, icon: 'event', color: 'text-slate-600 dark:text-slate-400', bg: 'bg-slate-100 dark:bg-slate-800',
        };
}

// Sugiere mañana 10:00am como punto de partida editable, en vez de dejar
// el campo de fecha vacío (evita fricción al activar el seguimiento).
export function getDefaultFollowUpDate() {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(10, 0, 0, 0);
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
